export default __webpack_public_path__ + "static/media/dack.c50b1adb.png";